import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jquidraggable',
	templateUrl:'./JQUIDraggablePluginCompPage.html',
	styles: [],
	styleUrls:['./JQUIDraggablePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUIDraggablePluginCompPage
{
	mdContent_1015 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.draggable.JQUIDraggable;
\`\`\``;
	mdContent_1016 = `\`\`\`java
JQUIDraggable()
\`\`\``;
	mdContent_1017 = `\`\`\`java
JQUIDraggable&lt;?&gt; drag = new JQUIDraggable&lt;&gt;();
drag.setText("Drag me!");
drag.getOptions().setContainment("parent");
drag.getOptions().setAxis("x");
drag.getOptions().setOpacity(0.7);
\`\`\``;
}
